import React from 'react'
import PropTypes from 'prop-types'

import NewsletterBackButton from '@/components/blocks/NewsletterBackButton'

import styles from './NewsletterHeader.module.scss'

export default function NewsletterHeader({ title }) {
  return (
    <header className={styles.wrapper}>
      <NewsletterBackButton />
      <h1 className="text-center">{title}</h1>
    </header>
  )
}

NewsletterHeader.propTypes = {
  title: PropTypes.string.isRequired,
}
